module.exports = __webpack_public_path__ + "46242c2be537fbe36d6c8bcd5e04abde.svg";